import "./App.css";
import "./styles/globals.css";
import WindowResizer from "./components/WindowResizer";
import RouteTestingMapWrapper from "./components/map/RouteTestingMapWrapper";
import Introduction from "./components/Introduction";
import WhatWeStudied from "./components/WhatWeStudied";
import ExistingConditions from "./components/ExistingConditions";
import WhatWeLearned from "./components/WhatWeLearned";
import CirculationChanges from "./components/ui/CirculationChanges";
import WhatsNext from "./components/WhatsNext";

function App() {
  return (
    <>
      <WindowResizer />
      <div
        className="container pb-20 px-4 md:px-8 space-y-[50px] max-w-[700px]"
        style={{ maxWidth: "900px", margin: "auto" }}
      >
        <Introduction />
        <WhatWeStudied />
        <ExistingConditions />
        <WhatWeLearned />
        <CirculationChanges />
        <RouteTestingMapWrapper />
        <WhatsNext />
      </div>
    </>
  );
}

export default App;
